import { map, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PriceFilteringAction } from '@cbridge-packages/price-filtering-profile';

export const reloadPriceFilteringListEpic: IEpic = (action$, state$) => action$.pipe(
  isTypeOf(
    PriceFilteringAction.create.done,
    PriceFilteringAction.update.done,
    PriceFilteringAction.remove.done,
  ),
  withLatestFrom(state$),
  map(() => {
    return PriceFilteringAction.loadList.started();
  }),
);
